'use strict';

import { addEvent } from './addEvent/addEvent';
import { asideMenuInit } from './aside/aside';
// import { fslightboxInit } from './fslightbox/fslightbox';
import { tableWrapperInit } from './tableWrapper/tableWrapper';
import { pageBaner } from './pageBaner/pageBaner';
import { initSmoothSticky } from './smoothSticky/smoothSticky';
import { initTocSpy } from './scrollToAnchor/scrollToAnchor';

document.addEventListener('DOMContentLoaded', () => {
  asideMenuInit();
  // fslightboxInit();
  tableWrapperInit();
  pageBanerInit();
  faqList();
  initProductFilters();
});

addEvent(window, 'load', () => {
  if (!document.body.classList.contains('mobile'))
    initSmoothSticky('.my-sticky', 0);

  initTocSpy('active', 460);
});

addEvent(window, 'resize', () => { });

addEvent(window, 'scroll', () => { });

function pageBanerInit() {
  const elements = document.querySelectorAll('.page-baner-container');
  elements.forEach(element => {
    new pageBaner(element);
  });
}

function faqList() {
  // Pobierz wszystkie elementy FAQ
  const lists = document.querySelectorAll('.faq-list .faq-list__item');

  lists.forEach(list => {
    const description = list.querySelector('.faq-list__description');
    const title = list.querySelector('.faq-list__title');

    // Ukryj opis domyślnie
    description.style.maxHeight = '0';
    description.style.overflow = 'hidden';
    description.style.transition = 'max-height 0.3s ease';

    // Obsługa kliknięcia
    title.addEventListener('click', function () {
      if (!list.classList.contains('show')) {
        list.classList.add('show');
        description.style.maxHeight = description.scrollHeight + 'px';
      } else {
        list.classList.remove('show');
        description.style.maxHeight = '0';
      }
    });
  });
}

function initProductFilters() {
  const form = document.querySelector('.products-filter-form');
  if (!form) return;

  const selects = form.querySelectorAll('select');
  const products = document.querySelectorAll('.product-list__item');

  // komunikat "brak wyników"
  let emptyState = document.querySelector('.products-empty-state');

  // jeśli nie istnieje w HTML – tworzymy go
  if (!emptyState) {
    emptyState = document.createElement('div');
    emptyState.className = 'products-empty-state';
    emptyState.textContent = 'Brak produktów spełniających kryteria';
    emptyState.style.display = 'none';

    const container = document.querySelector('.product-list');
    if (container) {
      container.appendChild(emptyState);
    }
  }

  function applyFilters() {
    const activeFilters = [];

    selects.forEach(select => {
      if (select.value) {
        const id = select.value.replace('filtr_', '');
        activeFilters.push(id);
      }
    });

    let visibleCount = 0;

    products.forEach(product => {
      const data = product.dataset.filters || '';
      const productFilters = data ? data.split(',') : [];

      const show =
        activeFilters.length === 0
          ? true
          : activeFilters.every(f => productFilters.includes(f));

      product.classList.toggle('hidden', !show);

      if (show) visibleCount++;
    });

    // kontrola komunikatu
    if (visibleCount === 0) {
      emptyState.style.display = 'block';
    } else {
      emptyState.style.display = 'none';
    }
  }

  selects.forEach(select => {
    select.addEventListener('change', applyFilters);
  });

  applyFilters();
}
